export default class AppState {
  constructor(public authenticated: boolean, public initialized: boolean) {}
}
